import { ImportsExports } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const CSV = new CIMSPageItem({
  id: 'd82d8e1f-5d64-4df4-b4c8-536fa24c5ec3',
  name: 'CSV',
  pathname: 'csv',
  module: ImportsExports,
})
export const PDFReports = new CIMSPageItem({
  id: 'ddc6e3f3-bd9d-4097-9259-b7f1e7d5877f',
  name: 'Single Reports',
  pathname: 'single',
  module: ImportsExports,
})
export const BatchReports = new CIMSPageItem({
  id: 'eceded5b-417e-4db9-9ec0-4e4f0ed9d01b',
  name: 'Batch Reports',
  pathname: 'batch',
  module: ImportsExports,
})
export const PDFDesignLayers = new CIMSPageItem({
  id: '0d410307-8460-4f1a-ae63-6f3ec4e2db97',
  name: 'PDF Design Layers',
  pathname: 'design-layers',
  module: ImportsExports,
})
export const PhotoExports = new CIMSPageItem({
  id: 'f75b7273-d9a5-41fd-afd6-0c931ce2c753',
  name: 'Photo Exports',
  pathname: 'photo',
  module: ImportsExports,
})
export const Filenames = new CIMSPageItem({
  id: 'f0f47801-f630-43e3-b8ce-315a262ae0b1',
  name: 'Filenames',
  pathname: 'filenames',
  module: ImportsExports,
})
export type ExportsPageItem =
  | typeof CSV
  | typeof PDFReports
  | typeof BatchReports
  | typeof PDFDesignLayers
  | typeof PhotoExports
  | typeof Filenames
